const withProxy = url => `${process.env.REACT_APP_DOCS_SITE_PROXY}?url=${url}`;

export default withProxy;
